<script>
export default {
  props: {
    tabs: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentTabIndex: 0,
    }
  },
  computed: {
    currentTab() {
      return this.tabs[this.currentTabIndex]
    },
  },
}
</script>

<template>
  <BaseFieldset>
    <template v-slot:legend>
      <BaseButton
        v-for="(tab, tabIndex) in tabs"
        :key="tab"
        :active="tab === currentTab"
        @click="currentTabIndex = tabIndex"
      >
        {{ tab }}
      </BaseButton>
    </template>
    <slot :name="currentTab" />
  </BaseFieldset>
</template>
